<p-dialog header="Mode Dégradé Activé" [(visible)]="showDegradedModal" [modal]="true" [closable]="true">
  <p>Le système est actuellement en mode dégradé. Les modifications, créations et suppressions sont désactivées. <br>
    Ce mode se produit lorsque le serveur de base de l'ogrn est down et que vous êtes actuellement sur une instance de secours
  </p>
</p-dialog>
<router-outlet></router-outlet>
